interface WorkerSharePieProps {
    percent: number;
}

const RADIUS = 15.9155;
const CIRCUMFERENCE = 100;

const WorkerSharePie = ({ percent }: WorkerSharePieProps) => {
    const raw = Number(percent) || 0;
    const filled = Math.min(CIRCUMFERENCE, Math.max(0, raw));
    const over = raw > 100;
    const full = !over && filled >= 99.5;
    const sliceClass = over
        ? 'worker-share-pie__slice is-over'
        : full
          ? 'worker-share-pie__slice is-full'
          : 'worker-share-pie__slice';
    const label = Number.isInteger(Math.round(raw * 10) / 10)
        ? `${Math.round(raw)}%`
        : `${(Math.round(raw * 10) / 10).toFixed(1)}%`;

    return (
        <div className="worker-share-cell">
            <svg
                className="worker-share-pie"
                viewBox="0 0 36 36"
                aria-hidden="true"
            >
                <circle
                    className="worker-share-pie__track"
                    cx="18"
                    cy="18"
                    r={RADIUS}
                />
                {filled > 0 ? (
                    <circle
                        className={sliceClass}
                        cx="18"
                        cy="18"
                        r={RADIUS}
                        strokeDasharray={`${filled} ${CIRCUMFERENCE - filled}`}
                        strokeDashoffset="25"
                        strokeLinecap={filled > 0 && filled < 100 ? 'round' : 'butt'}
                    />
                ) : null}
            </svg>
            <span className={`fs-12 ${over ? 'text-danger' : 'text-muted'}`}>{label}</span>
        </div>
    );
};

export default WorkerSharePie;
